<template>
    <div class="Information">
        <div class="row">
            <div class="col">
                <ActionButton class="DeleteButton"
                              :requires-confirmation="true"
                              confirmation-string="WARNING: You are about to delete this family's entire case file.  This is the equivilant of shredding an entire paper file."
                              endpoint="Foster/ResourceFamily/DeleteFosterResourceFamily"
                              :payload="{FosterResourceFamilyID: RecordData.Id}"
                              :perform-global-update="true"
                              button-variant="danger"
                              button-string="DELETE FAMILY RECORD"
                              button-size="md"
                              v-on:success="OnRecordDeleted"
                              style="white-space: normal;"/>
            </div>
        </div>
    </div>
</template>

<script>

    //import components
    import ActionButton from '../../../../Core/ItemEditors/ActionButton.vue';

    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {

            };
        },
        methods: {

            OnRecordDeleted() {
                this.$parent.CloseRecord();
            }
        },
        components: {
            ActionButton
        },
        mounted() {

        },
        computed: {
            
        }
    }
</script>

<style scoped>
    .DeleteButton {
    display: inline-block;
    font-size:4px;
    }
</style>